import logger from '@cvg/react-logger'

const options = {
  appId: import.meta.env.PUBLIC_APP_ID,
  env: import.meta.env.PUBLIC_ENV
}

export default logger(options)
